export default __webpack_public_path__ + "static/media/login.8bf58e68.svg";